import { ServiceMode } from 'state/order';

interface IHeading {
  icon: string;
  title: string;
}
export const getHeadingForServiceMode = (serviceMode: ServiceMode): IHeading | null => {
  let heading: IHeading | null;

  switch (serviceMode) {
    case ServiceMode.DELIVERY:
      heading = { icon: 'delivery', title: 'delivery' };
      break;
    case ServiceMode.CURBSIDE:
      heading = { icon: 'driveThru', title: 'curbside' };
      break;
    case ServiceMode.TAKEOUT:
      heading = { icon: 'store', title: 'pickUp' };
      break;
    case ServiceMode.DRIVE_THRU:
      heading = { icon: 'driveThru', title: 'driveThru' };
      break;
    case ServiceMode.EAT_IN:
      heading = { icon: 'restaurant', title: 'dineIn' };
      break;
    default:
      heading = null;
  }

  return heading;
};
